var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_4980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8229 12.5205C34.196 12.5205 34.5537 12.6687 34.8175 12.9325C35.0813 13.1963 35.2295 13.554 35.2295 13.9271L35.2295 23.875C35.2231 24.2438 35.0721 24.5954 34.809 24.854C34.5459 25.1125 34.1918 25.2574 33.8229 25.2574C33.454 25.2574 33.0999 25.1125 32.8368 24.854C32.5737 24.5954 32.4227 24.2438 32.4163 23.875L32.4163 17.3233L14.9219 34.8177C14.658 35.0816 14.3002 35.2298 13.9271 35.2298C13.554 35.2298 13.1961 35.0816 12.9323 34.8177C12.6685 34.5539 12.5202 34.196 12.5202 33.8229C12.5202 33.4498 12.6685 33.092 12.9323 32.8281L30.4267 15.3337L23.875 15.3337C23.6882 15.337 23.5027 15.303 23.3292 15.2338C23.1557 15.1645 22.9977 15.0614 22.8644 14.9305C22.7312 14.7995 22.6254 14.6434 22.5531 14.4711C22.4809 14.2988 22.4437 14.1139 22.4437 13.9271C22.4437 13.7403 22.4809 13.5553 22.5531 13.3831C22.6254 13.2108 22.7312 13.0546 22.8644 12.9237C22.9977 12.7928 23.1557 12.6897 23.3292 12.6204C23.5027 12.5512 23.6882 12.5172 23.875 12.5205L33.8229 12.5205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_4980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.7644,
    height: 33.7644,
    fill: "white",
    transform: "translate(47.75 23.875) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftsm);
export default __webpack_public_path__ + "static/media/leftsm.5cff30b87c8f32ecd3426a79e9b6ead3.svg";
export { ForwardRef as ReactComponent };